module.exports = __webpack_public_path__ + "img/hamberger.ba9c9049.svg";